export default __webpack_public_path__ + "static/media/Sinnoh.ab31b3af.png";